<template>
  <div class="column" :class="columnSize">
    <b-radio type="is-dark" native-value :value="value" @input="onInput">
      N/A
    </b-radio>
    <b-radio type="is-dark" :native-value="1" :value="value" @input="onInput">
      Has Asset
    </b-radio>
    <b-radio type="is-dark" :native-value="0" :value="value" @input="onInput">
      No Asset
    </b-radio>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    columnSize: {
      type: Object | String,
      default: "is-12"
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldHasAsset.vue